<lib-alerts-dsn (onEmitUnreadNotificationsEvent)="handleEmitUnreadNotificationsEvent($event)" (onRejectEvent)="handleRejectEvent($event)"
                [configuration]="configuration"
                [gestionSalariesRoute]="gestionSalariesRoute"></lib-alerts-dsn>
